var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankingImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2845.66 2904.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#18174a;}.cls-4{fill:#91b3fa;}.cls-5{fill:#bdd0fb;}.cls-6{fill:#2b69b3;}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{opacity:0.78;}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15{fill:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-10);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:url(#linear-gradient-12);}.cls-19{fill:url(#linear-gradient-13);}.cls-20{fill:url(#linear-gradient-14);}.cls-21{fill:url(#linear-gradient-15);}.cls-22{fill:url(#linear-gradient-16);}.cls-23{opacity:0.54;}.cls-24{fill:url(#linear-gradient-17);}.cls-25{fill:url(#linear-gradient-18);}.cls-26{fill:url(#linear-gradient-19);}.cls-27{fill:url(#linear-gradient-20);}.cls-28{fill:url(#linear-gradient-21);}.cls-29{fill:url(#linear-gradient-22);}.cls-30{fill:url(#linear-gradient-23);}.cls-31{fill:url(#linear-gradient-24);}.cls-32{fill:url(#linear-gradient-25);}.cls-33{fill:url(#linear-gradient-26);}.cls-34{fill:url(#linear-gradient-27);}.cls-35{fill:url(#linear-gradient-28);}.cls-36{fill:url(#linear-gradient-29);}.cls-37{fill:url(#linear-gradient-30);}.cls-38{fill:url(#linear-gradient-31);}.cls-39{fill:url(#linear-gradient-32);}.cls-40{fill:url(#linear-gradient-33);}.cls-41{fill:url(#linear-gradient-34);}.cls-42{fill:url(#linear-gradient-35);}.cls-43{fill:url(#linear-gradient-36);}.cls-44{fill:url(#linear-gradient-37);}.cls-45{fill:url(#linear-gradient-38);}.cls-46{fill:url(#linear-gradient-39);}.cls-47{fill:url(#linear-gradient-40);}.cls-48{fill:url(#linear-gradient-41);}.cls-49{fill:url(#linear-gradient-42);}.cls-50{fill:url(#linear-gradient-43);}.cls-51{fill:url(#linear-gradient-44);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3180.71,
    y1: 3653.97,
    x2: 705.05,
    y2: 579.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 18000.49,
    y1: -28588.28,
    x2: 17629.41,
    y2: -27927.09,
    gradientTransform: "translate(-1617.6 3648.14) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 18277.63,
    y1: -28432.75,
    x2: 17906.56,
    y2: -27771.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 20193.73,
    y1: -29795.55,
    x2: 19822.65,
    y2: -29134.36,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -1518.18, 3747.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1075.6,
    y1: 476.89,
    x2: 1255.19,
    y2: 268.44,
    gradientTransform: "translate(555.53 -812.73) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1356.67,
    y1: 116.4,
    x2: 825.62,
    y2: 918.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1317.7,
    y1: -31.88,
    x2: 1253.6,
    y2: 318.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 951.74,
    y1: 1179.19,
    x2: 1131.33,
    y2: 970.74,
    gradientTransform: "translate(32.79 -37.23) rotate(1.91)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1232.81,
    y1: 818.7,
    x2: 701.76,
    y2: 1620.97,
    gradientTransform: "translate(1015.86 -519.45) rotate(45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1226.73,
    y1: 683.45,
    x2: 1108.66,
    y2: 1071.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 646.5,
    y1: 914.69,
    x2: 927.07,
    y2: 589.02,
    gradientTransform: "translate(685.04 -488.95) rotate(45)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1085.61,
    y1: 351.49,
    x2: 255.95,
    y2: 1604.87,
    gradientTransform: "translate(685.04 -488.95) rotate(45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1088.09,
    y1: 138,
    x2: 909.3,
    y2: 681.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1164.04,
    y1: 930.9,
    x2: 1376.76,
    y2: 683.99,
    gradientTransform: "translate(884.63 -777.68) rotate(45)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1496.97,
    y1: 503.91,
    x2: 867.94,
    y2: 1454.18,
    gradientTransform: "translate(884.63 -777.68) rotate(45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1487.58,
    y1: 389.42,
    x2: 1339.15,
    y2: 821.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1403.33,
    y1: 1356.26,
    x2: 1056.85,
    y2: 1443.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1884.39,
    y1: 714.51,
    x2: 1395.24,
    y2: 1352.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2137.02,
    y1: 908.32,
    x2: 1647.87,
    y2: 1545.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 362.02,
    y1: 1038.37,
    x2: 311.89,
    y2: 887.99,
    gradientTransform: "translate(1290.1)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1554.59,
    y1: 912.52,
    x2: 1734.76,
    y2: 990.85,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1543.37,
    y1: 938.34,
    x2: 1723.53,
    y2: 1016.68,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2023.67,
    y1: 2839.74,
    x2: 2247.58,
    y2: 2839.74,
    gradientTransform: "matrix(-1, 0, 0, 1, 3920.4, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2044.34,
    y1: 2734.59,
    x2: 2107.41,
    y2: 2734.59,
    gradientTransform: "matrix(-1, 0, 0, 1, 3920.4, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1643.37,
    y1: 2682.02,
    x2: 1718.75,
    y2: 2682.02,
    gradientTransform: "matrix(-1, 0, 0, 1, 3920.4, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -553.52,
    y1: 2442.77,
    x2: -556.63,
    y2: 2367.39,
    gradientTransform: "translate(2037.98 -665.79) rotate(-7.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -343.52,
    y1: 2434.13,
    x2: -346.63,
    y2: 2358.74,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1867.6,
    y1: 1975.11,
    x2: 1985.23,
    y2: 1975.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1980.66,
    y1: 1533.86,
    x2: 1809.97,
    y2: 1862.1,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 2227.03,
    y1: 977.38,
    x2: 1737.88,
    y2: 1614.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 2161.96,
    y1: 913.45,
    x2: 1590.19,
    y2: 1758.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -542.26,
    y1: 2607.56,
    x2: -1076.64,
    y2: 3027.16,
    gradientTransform: "translate(1290.1)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -869.14,
    y1: 2613.62,
    x2: -897.19,
    y2: 2858.49,
    gradientTransform: "translate(1290.1)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -447.33,
    y1: 2728.28,
    x2: -981.71,
    y2: 3147.88,
    gradientTransform: "translate(1290.1)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -534.99,
    y1: 2572.23,
    x2: -563.05,
    y2: 2817.1,
    gradientTransform: "translate(1017.81 38.75) rotate(-3.61)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -757.2,
    y1: 1186.41,
    x2: -692.04,
    y2: 1008.46,
    gradientTransform: "translate(1290.1)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 700.22,
    y1: 1106.97,
    x2: 568.65,
    y2: 833.73,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 639.56,
    y1: 1136.18,
    x2: 507.99,
    y2: 862.93,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 903.88,
    y1: 1011.55,
    x2: 846.53,
    y2: 1652.5,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1268.37,
    y1: 958.74,
    x2: 1128.15,
    y2: 1105.19,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1113.08,
    y1: 1030.27,
    x2: 1055.73,
    y2: 1671.21,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 930.38,
    y1: 1403.37,
    x2: 367.02,
    y2: 1416.87,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 2064.94,
    y1: 168.84,
    x2: 1079.9,
    y2: 897.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 2030.87,
    y1: 122.78,
    x2: 1045.84,
    y2: 851.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -416.68,
    y: -404.43,
    width: 3710,
    height: 3710
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2499.64,2441.45c-56.87,59.87-110.67,98.47-153.18,129-499.71,358.55-1091,254-1216.65,228.51-185.56-37.69-544.26-110.54-803.59-415.51C-66.12,1922-5,1195.13,299.3,715.29,355,627.52,649,140.37,1246.66,62.25,1608.35,15,2030,110.33,2335.29,366.12,2976.18,903.07,2930.56,1987.79,2499.64,2441.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.65,2495.87A44.25,44.25,0,0,0,268.8,2540H2656.24a44.25,44.25,0,0,0,44.15-44.1l19.86-1372c0-24.26-28.58-71.62-81-68.06L306,995.44a111.27,111.27,0,0,0-114.16,113.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.24,2453.55A41.9,41.9,0,0,0,310,2495.32H2598.66a41.9,41.9,0,0,0,41.77-41.77l18.75-1245.5c-2.21-75-67.92-101.89-107.76-100.3l-2236.22-60a78.2,78.2,0,0,0-80.22,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2615.7,1861.85h-.09a6.12,6.12,0,0,1-6-6.21l1.48-101a6.12,6.12,0,0,1,6.12-6h.09a6.12,6.12,0,0,1,6,6.21l-1.48,101A6.12,6.12,0,0,1,2615.7,1861.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2619.34,1614.33h-.1a6.13,6.13,0,0,1-6-6.22l5.68-386.86c-.1-23-7.08-41.33-20.73-54.41-25.49-24.42-65.95-23.17-67.65-23.09l-714.75-19.17a6.11,6.11,0,0,1-6-6.28,5.86,5.86,0,0,1,6.28-6l714.33,19.17c4.44-.26,47.52-1,76.21,26.48,16.14,15.46,24.38,36.77,24.5,63.31l-5.68,387A6.13,6.13,0,0,1,2619.34,1614.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.97,
    y: 2533.32,
    width: 2814.69,
    height: 120.55,
    rx: 5.65,
    transform: "translate(2876.64 5187.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 2038.99,
    cy: 892.76,
    r: 515.1,
    transform: "translate(-34.07 1703.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 2038.99,
    cy: 892.76,
    r: 439.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2039,1354.39c-254.54,0-461.63-207.08-461.63-461.64S1784.45,431.12,2039,431.12s461.64,207.08,461.64,461.63S2293.54,1354.39,2039,1354.39Zm0-901.25c-242.4,0-439.61,197.21-439.61,439.61s197.21,439.62,439.61,439.62,439.62-197.21,439.62-439.62S2281.4,453.14,2039,453.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 2038.99,
    cy: 892.76,
    r: 268.01,
    transform: "translate(-34.07 1703.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2039,1182.79c-159.92,0-290-130.11-290-290s130.11-290,290-290,290,130.1,290,290S2198.92,1182.79,2039,1182.79Zm0-536c-135.64,0-246,110.35-246,246s110.35,246,246,246,246-110.35,246-246S2174.64,646.76,2039,646.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 2038.99,
    cy: 892.76,
    r: 103.84,
    transform: "translate(734.82 2696.54) rotate(-77.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2039,1018.61a125.86,125.86,0,1,1,125.86-125.86A126,126,0,0,1,2039,1018.61Zm0-207.67a81.82,81.82,0,1,0,81.82,81.81A81.9,81.9,0,0,0,2039,810.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2397.72,
    y: 164.75,
    width: 19.63,
    height: 743.45,
    transform: "translate(3730.61 2618.19) rotate(-135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2147.58,758.88c8-8,45.51,29.59,37.55,37.55L2045.87,905.91c-5.15,4.05-11.81-2.62-7.77-7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2677,280.87l70.72,7L2650.66,385a150.09,150.09,0,0,1-121,43.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2663.15,267l-7-70.72L2559,293.35a150.1,150.1,0,0,0-43.23,121h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1258.82,
    cy: 264.22,
    r: 133.89,
    transform: "translate(181.86 967.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1258.82,
    cy: 264.22,
    r: 129.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1152.08,215.89a5.43,5.43,0,0,1-4.85-7.88,125.11,125.11,0,0,1,134.12-66.68,5.44,5.44,0,0,1-1.95,10.7,114.81,114.81,0,0,0-20.58-1.85,113.57,113.57,0,0,0-101.88,62.73A5.44,5.44,0,0,1,1152.08,215.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1261.64,
    cy: 267.05,
    r: 109.55,
    transform: "translate(711.87 1433.58) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1250.89,348.49V336.57c-12.43-.5-24.72-3.43-33.45-7.25a6.91,6.91,0,0,1-3.81-8.15l3-11.1a7,7,0,0,1,9.43-4.55A80.7,80.7,0,0,0,1257,312c12,0,20.9-4.06,20.9-12.38,0-7.5-6.9-12-23.53-16.43-23.74-6.49-40.78-16.83-40.78-37.73,0-18.86,13.8-33.26,37.73-37.12V196.46a7,7,0,0,1,7-7h7a7,7,0,0,1,7,7v10.7a88.39,88.39,0,0,1,26.5,4.76,6.89,6.89,0,0,1,4.32,8.34l-2.78,10.27a6.92,6.92,0,0,1-9.14,4.67,72.43,72.43,0,0,0-26-4.72c-14.2,0-18.26,5.89-18.26,11.16,0,6.49,8.52,11,27,16.63,26.37,7.91,37.32,18.87,37.32,38.54,0,18.06-13.39,34.28-39.35,38.34v13.34a6.94,6.94,0,0,1-6.94,6.94h-7A6.94,6.94,0,0,1,1250.89,348.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 1134.96,
    cy: 966.52,
    r: 133.89,
    transform: "translate(-31.54 38.3) rotate(-1.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1134.96,
    cy: 966.52,
    r: 129.44,
    transform: "translate(-351.01 1085.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1028.22,918.19a5.34,5.34,0,0,1-2.44-.58,5.44,5.44,0,0,1-2.41-7.3,125.11,125.11,0,0,1,134.12-66.68,5.44,5.44,0,1,1-2,10.7,114.81,114.81,0,0,0-20.58-1.85,113.57,113.57,0,0,0-101.88,62.73A5.43,5.43,0,0,1,1028.22,918.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1137.78,
    cy: 969.35,
    r: 109.55,
    transform: "translate(-132.55 1757.03) rotate(-72.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1127,1050.79v-11.92c-12.43-.5-24.72-3.43-33.44-7.25a6.89,6.89,0,0,1-3.81-8.15l3-11.1a7,7,0,0,1,9.44-4.55,80.7,80.7,0,0,0,30.88,6.51c12,0,20.89-4.06,20.89-12.38,0-7.5-6.9-12-23.53-16.43-23.73-6.49-40.77-16.83-40.77-37.73,0-18.86,13.79-33.26,37.73-37.12V898.75a6.94,6.94,0,0,1,6.94-6.94h7a7,7,0,0,1,6.95,6.94v10.71a88.47,88.47,0,0,1,26.51,4.76,6.91,6.91,0,0,1,4.32,8.34l-2.79,10.27a6.91,6.91,0,0,1-9.14,4.67,72.39,72.39,0,0,0-26-4.72c-14.2,0-18.26,5.89-18.26,11.16,0,6.49,8.52,10.95,27,16.63,26.37,7.91,37.32,18.87,37.32,38.54,0,18.06-13.38,34.28-39.35,38.34v13.34a6.94,6.94,0,0,1-6.94,6.94h-7A6.94,6.94,0,0,1,1127,1050.79Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 932.74,
    cy: 582.44,
    r: 209.18,
    transform: "translate(-138.66 830.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 932.74,
    cy: 582.44,
    r: 202.22,
    transform: "translate(-138.66 830.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M766,503.32a5,5,0,0,1-2.19-.52,4.89,4.89,0,0,1-2.16-6.56A190.76,190.76,0,0,1,932.74,390.89,193.45,193.45,0,0,1,967.29,394a4.88,4.88,0,1,1-1.75,9.6,183.21,183.21,0,0,0-32.8-3,181,181,0,0,0-162.4,100A4.86,4.86,0,0,1,766,503.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 937.14,
    cy: 586.85,
    r: 171.16,
    transform: "translate(-140.48 834.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M920.35,714.09V695.47c-19.41-.78-38.61-5.36-52.25-11.33a10.77,10.77,0,0,1-6-12.73l4.73-17.34a10.85,10.85,0,0,1,14.74-7.1c13.52,5.67,30.23,10.15,48.24,10.15,18.69,0,32.64-6.34,32.64-19.33,0-11.72-10.78-18.69-36.76-25.67C888.66,602,862,585.82,862,553.18c0-29.47,21.55-52,58.94-58V476.57a10.85,10.85,0,0,1,10.85-10.85h10.94a10.84,10.84,0,0,1,10.85,10.85v16.72c18,.72,31,3.79,41.42,7.43a10.8,10.8,0,0,1,6.74,13l-4.35,16a10.81,10.81,0,0,1-14.28,7.3,113,113,0,0,0-40.62-7.37c-22.18,0-28.52,9.19-28.52,17.43,0,10.14,13.31,17.11,42.15,26,41.2,12.35,58.31,29.47,58.31,60.21,0,28.2-20.92,53.55-61.48,59.89v20.84a10.85,10.85,0,0,1-10.85,10.85H931.2A10.85,10.85,0,0,1,920.35,714.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 1381.06,
    cy: 679,
    r: 158.59,
    transform: "translate(-75.63 1175.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 1381.06,
    cy: 679,
    r: 153.32,
    transform: "translate(-75.63 1175.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1254.63,620.22a5,5,0,0,1-2.21-.52,4.9,4.9,0,0,1-2.16-6.6,145.81,145.81,0,0,1,130.8-80.53,148.31,148.31,0,0,1,26.41,2.37,4.91,4.91,0,0,1-1.76,9.66,138,138,0,0,0-24.65-2.22,136.05,136.05,0,0,0-122,75.15A4.91,4.91,0,0,1,1254.63,620.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1384.4,
    cy: 682.35,
    r: 129.77,
    transform: "translate(-77.01 1178.77) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1371.67,778.82V764.7c-14.72-.59-29.28-4.07-39.62-8.59a8.17,8.17,0,0,1-4.51-9.65l3.59-13.15a8.23,8.23,0,0,1,11.17-5.39,95.59,95.59,0,0,0,36.57,7.71c14.18,0,24.75-4.81,24.75-14.66,0-8.89-8.17-14.18-27.87-19.46-28.11-7.69-48.29-19.94-48.29-44.69,0-22.35,16.34-39.4,44.69-44V598.73a8.22,8.22,0,0,1,8.22-8.22h8.3a8.22,8.22,0,0,1,8.22,8.22v12.68a104.58,104.58,0,0,1,31.4,5.64,8.18,8.18,0,0,1,5.12,9.88l-3.3,12.16a8.2,8.2,0,0,1-10.83,5.54,85.61,85.61,0,0,0-30.8-5.59c-16.81,0-21.62,7-21.62,13.21,0,7.69,10.09,13,32,19.71,31.23,9.37,44.2,22.34,44.2,45.65,0,21.38-15.85,40.6-46.61,45.41v15.8a8.22,8.22,0,0,1-8.22,8.22h-8.3A8.22,8.22,0,0,1,1371.67,778.82Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2457.88,
    y: 1956.95,
    width: 112.91,
    height: 511.06,
    transform: "translate(5028.67 4424.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2269.21,
    y: 2132.6,
    width: 112.91,
    height: 335.42,
    transform: "translate(4651.33 4600.61) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2080.54,
    y: 1698.51,
    width: 112.91,
    height: 769.5,
    transform: "translate(4274 4166.52) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1891.87,
    y: 2283.15,
    width: 112.91,
    height: 184.86,
    transform: "translate(3896.66 4751.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1703.21,
    y: 1801.38,
    width: 112.91,
    height: 666.63,
    transform: "translate(3519.33 4269.4) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1514.54,
    y: 1916.81,
    width: 112.92,
    height: 551.2,
    transform: "translate(3141.99 4384.82) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1325.87,
    y: 2042.27,
    width: 112.91,
    height: 425.74,
    transform: "translate(2764.66 4510.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1137.21,
    y: 1542.94,
    width: 112.91,
    height: 925.07,
    transform: "translate(2387.32 4010.95) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 948.54,
    y: 1640.8,
    width: 112.91,
    height: 827.21,
    transform: "translate(2009.99 4108.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 759.87,
    y: 1788.84,
    width: 112.91,
    height: 679.17,
    transform: "translate(1632.65 4256.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 571.2,
    y: 2300.3,
    width: 112.91,
    height: 167.71,
    transform: "translate(1255.32 4768.31) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 382.53,
    y: 1974.52,
    width: 112.91,
    height: 493.49,
    transform: "translate(877.98 4442.53) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1077.39,1419.82s-16.2-42.65-35.12-38.75-39.63,18.45-39.63,18.45l-30.4,41.11s85.34,33.62,115.36,14.35c0,0,87.17,15.07,197.24-3-15.93-33.64-25.43-67.32-31-93.46C1198.08,1390.07,1138,1413.65,1077.39,1419.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1539.13,1110.48s-124.8,157.19-285.3,248c5.58,26.14,15.08,59.82,31,93.46,83.26-13.66,179.62-46.26,261.31-118.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1694.78,1807.19c-24.41-115.93-48.81-183-130.54-402.8-25.72-69.15-49.07-139.11-37.78-212l12.67-81.88s158.82-53.75,334.87-2.27c0,0,240.19,104.34,77,619.66C1877.51,1810.14,1791.45,1833.59,1694.78,1807.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1566.17,1006l41.18,98.94a19.74,19.74,0,0,0,14.9,11.85c23.74,4.07,81.17,10.43,118.88-14.37a9.59,9.59,0,0,0,2.57-13.48l-76.09-109.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1608.76,854.59c-1.73,1.63-73,141.58-73,141.58l80.77,39,87.25-122.61S1637.72,827.34,1608.76,854.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1667.08,927.26l-40.28,67.16a12.48,12.48,0,0,1-2.21,2.75c-4.8,4.46-21.21,17.44-33.89-.23-10.81-15.07-21-28.76-31.82-34.41a12.88,12.88,0,0,0-17.39,5.72c-6.63,13.15-19.49,40-27.57,65.4a12.82,12.82,0,0,0,7.47,15.72c16.35,6.63,48.68,18.62,77.36,22.57a12.86,12.86,0,0,0,12.18-5.18c12.34-16.9,47.13-64.15,59-76,11-11,31.38-6.85,40.56-4.21a12.94,12.94,0,0,0,10.29-1.35c9.3-5.61,25.54-19.57,10.69-43.2a12.89,12.89,0,0,1,4-17.52c10.39-6.83,21.66-19.66,10.92-40.43-10.88-21-30.29-22.92-43.52-21.31a13.38,13.38,0,0,1-14-7.8,8.5,8.5,0,0,0-6.64-5.24A12.49,12.49,0,0,1,1672.06,835c2.33-11.9.57-27.36-18.43-37.8-34.85-19.17-65.38,12.06-73.14,38.41s31.2,45,55.71,48.09c18,2.29,27.88,21.94,31.85,32.21A12.88,12.88,0,0,1,1667.08,927.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1653,1010.89s17.34-40.79,37.17-39.12,35.45,21.42,10.87,43.64C1670.42,1043,1653,1010.89,1653,1010.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1679.14,2828.91c38.36,3.32,104.94,8.71,157.42,11,31.55,1.38,49.71-1.71,60.17-5.89,0,1.18,0,2.29-.1,3.33a10.85,10.85,0,0,1-10.31,10.25c-99.17,5.53-178,1.91-206.12.2a7.73,7.73,0,0,1-6.29-11.61A63.63,63.63,0,0,1,1679.14,2828.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1836.56,2839.93c-52.48-2.31-119.06-7.7-157.42-11,37.72-46.26,157.42-77.45,157.42-77.45h33.81c23.25,33.52,26.61,65.43,26.36,82.58C1886.27,2838.22,1868.11,2841.31,1836.56,2839.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1876.06,2696.27l-3.17,62.6a14.29,14.29,0,0,1-12.2,13.45,55.61,55.61,0,0,1-25.4-2.1,16.93,16.93,0,0,1-11.37-13L1813,2696.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2315.17,2839.46c16.63-2.32,24.16-11,27.32-20.2l.06.25c2.45,9.74-3.23,19.84-14.57,24.64-13.71,5.81-28.7,6.8-40.34,6.32-12.48-.52-23.94-5.68-30.24-13.95l-.09-.13C2269.84,2842.6,2287.43,2843.33,2315.17,2839.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2236.74,2695.87h27.88c42.47-.87,69.14,88.7,77.87,123.39-3.16,9.23-10.69,17.88-27.32,20.2-27.74,3.87-45.33,3.14-57.86-3.07-22.95-30.19-34.32-74.4-39.79-100.21C2211.3,2706.83,2236.74,2695.87,2236.74,2695.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2261,2637.76l15.48,61.57a16.7,16.7,0,0,1-8.7,18.94c-8.66,4.45-20.85,9.12-32.06,7.77a14,14,0,0,1-11.39-9.31l-22.72-64.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2279.51,2655.56c-19.27,17.08-81.92,19.34-81.92,19.34-225.67-541.65-319.76-690.76-319.76-690.76,32.59,204.44,7,729.21,7,729.21-37.24,16.44-85.25,0-85.25,0-3-334.7-50.15-694.34-110.92-924.46,152.53-3.43,235.42-36.68,261.91-57.63C2077.73,1936.24,2279.51,2655.56,2279.51,2655.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1650.25,1940.25l28.07,174.56a57.5,57.5,0,0,0,63.84,47.81l420.07-51.24a41.48,41.48,0,0,0,36.54-40.27c.9-45.11-.87-125.38-19.8-198.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1745.64,2151.76a1.16,1.16,0,0,1,0-2.31c1.61,0,3.24-.18,4.85-.38l4.27-.52a1.13,1.13,0,0,1,1.29,1,1.16,1.16,0,0,1-1,1.29l-4.27.52c-1.68.21-3.38.34-5.06.39Zm30.69-3.52a1.16,1.16,0,0,1-.14-2.31l9.2-1.12a1.13,1.13,0,0,1,1.29,1,1.16,1.16,0,0,1-1,1.29l-9.2,1.12Zm-51.88,0a1.25,1.25,0,0,1-.42-.08,56,56,0,0,1-8.52-4.08,1.16,1.16,0,0,1,1.17-2,53.34,53.34,0,0,0,8.18,3.91,1.16,1.16,0,0,1-.41,2.25Zm82.55-3.74a1.16,1.16,0,0,1-.14-2.31l9.2-1.12a1.13,1.13,0,0,1,1.29,1,1.16,1.16,0,0,1-1,1.29l-9.21,1.12Zm30.67-3.74a1.16,1.16,0,0,1-.14-2.31l9.2-1.12a1.12,1.12,0,0,1,1.29,1,1.16,1.16,0,0,1-1,1.29l-9.21,1.12Zm30.67-3.74a1.16,1.16,0,0,1-.14-2.31l9.2-1.12a1.11,1.11,0,0,1,1.29,1,1.16,1.16,0,0,1-1,1.29l-9.2,1.12Zm30.67-3.74a1.16,1.16,0,0,1-.14-2.31l9.2-1.12a1.12,1.12,0,0,1,1.3,1,1.17,1.17,0,0,1-1,1.29l-9.2,1.12Zm-199-3.34a1.17,1.17,0,0,1-.93-.46,55.1,55.1,0,0,1-5-8,1.16,1.16,0,0,1,2.06-1.06,54.57,54.57,0,0,0,4.81,7.68,1.15,1.15,0,0,1-.92,1.85Zm229.62-.4a1.16,1.16,0,0,1-.14-2.31l9.2-1.12a1.12,1.12,0,0,1,1.3,1,1.17,1.17,0,0,1-1,1.29l-9.2,1.12Zm30.68-3.74a1.16,1.16,0,0,1-.15-2.31l9.2-1.13a1.14,1.14,0,0,1,1.3,1,1.15,1.15,0,0,1-1,1.29l-9.2,1.13Zm30.67-3.75a1.16,1.16,0,0,1-1.15-1,1.14,1.14,0,0,1,1-1.28l9.21-1.13a1.13,1.13,0,0,1,1.29,1,1.15,1.15,0,0,1-1,1.29l-9.2,1.12Zm30.67-3.74a1.16,1.16,0,0,1-.15-2.31l9.21-1.12a1.13,1.13,0,0,1,1.29,1,1.16,1.16,0,0,1-1,1.29l-9.2,1.12Zm30.67-3.74a1.16,1.16,0,0,1-.15-2.31l9.21-1.12a1.13,1.13,0,0,1,1.29,1,1.16,1.16,0,0,1-1,1.29l-9.2,1.12Zm30.67-3.74a1.16,1.16,0,0,1-.14-2.31l9.2-1.12a1.13,1.13,0,0,1,1.29,1,1.16,1.16,0,0,1-1,1.29l-9.2,1.12Zm30.67-3.74a1.16,1.16,0,0,1-.14-2.31l9.2-1.12a1.11,1.11,0,0,1,1.29,1,1.16,1.16,0,0,1-1,1.29l-9.2,1.12Zm30.67-3.74a1.16,1.16,0,0,1-.14-2.31l6-.73c1.05-.13,2.09-.3,3.11-.51a1.16,1.16,0,0,1,.47,2.27c-1.09.22-2.18.4-3.29.54l-6,.73Zm-455.26-1.91a1.15,1.15,0,0,1-1.14-1l-1.47-9.15a1.15,1.15,0,1,1,2.28-.37l1.48,9.15a1.16,1.16,0,0,1-1,1.33Zm483.43-9.11a1.15,1.15,0,0,1-.85-.37,1.17,1.17,0,0,1,.06-1.64,38.79,38.79,0,0,0,5.83-6.83,1.16,1.16,0,1,1,1.92,1.29,40.62,40.62,0,0,1-6.17,7.24A1.14,1.14,0,0,1,2172.55,2092.33Zm-488.33-21.39a1.15,1.15,0,0,1-1.14-1l-1.47-9.15a1.15,1.15,0,1,1,2.28-.37l1.47,9.16a1.15,1.15,0,0,1-1,1.32Zm500.91-6h-.05a1.16,1.16,0,0,1-1.11-1.21v-.63c.06-2.75.1-5.61.13-8.6a1.16,1.16,0,0,1,1.16-1.14h0a1.15,1.15,0,0,1,1.15,1.16q0,4.5-.13,8.6c0,.23,0,.47,0,.71A1.15,1.15,0,0,1,2185.13,2065Zm-505.81-24.55a1.18,1.18,0,0,1-1.15-1l-1.47-9.15a1.16,1.16,0,1,1,2.29-.37l1.47,9.16a1.17,1.17,0,0,1-1,1.33Zm505.91-6.35a1.16,1.16,0,0,1-1.16-1.14c0-3-.1-6.1-.18-9.26a1.17,1.17,0,0,1,1.14-1.19h0a1.15,1.15,0,0,1,1.16,1.13q.12,4.76.18,9.28a1.16,1.16,0,0,1-1.14,1.18Zm-510.82-24.16a1.15,1.15,0,0,1-1.14-1l-1.47-9.15a1.15,1.15,0,1,1,2.28-.37l1.47,9.15a1.15,1.15,0,0,1-1,1.33Zm509.86-6.73a1.16,1.16,0,0,1-1.16-1.11q-.22-4.56-.5-9.24a1.16,1.16,0,1,1,2.31-.14c.19,3.13.35,6.22.5,9.27a1.16,1.16,0,0,1-1.1,1.22Zm-514.76-23.77a1.17,1.17,0,0,1-1.15-1l-1.47-9.15a1.16,1.16,0,1,1,2.29-.37l1.47,9.15a1.16,1.16,0,0,1-1,1.33Zm512.67-7.07a1.15,1.15,0,0,1-1.15-1.06c-.27-3-.56-6.12-.86-9.21a1.16,1.16,0,0,1,1-1.27,1.12,1.12,0,0,1,1.26,1q.47,4.65.86,9.24a1.16,1.16,0,0,1-1,1.26Zm-517.58-23.44a1.16,1.16,0,0,1-1.14-1l-1.47-9.16a1.15,1.15,0,1,1,2.28-.36l1.48,9.15a1.17,1.17,0,0,1-1,1.33Zm514.25-7.28a1.17,1.17,0,0,1-1.15-1c-.39-3-.81-6.1-1.26-9.16a1.16,1.16,0,0,1,1-1.31,1.13,1.13,0,0,1,1.32,1c.44,3.07.86,6.14,1.26,9.19a1.15,1.15,0,0,1-1,1.3Zm-506.49-3.05a1.16,1.16,0,0,1-.15-2.31l9.2-1.18a1.13,1.13,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.29l-9.19,1.18Zm30.65-3.92a1.17,1.17,0,0,1-1.15-1,1.16,1.16,0,0,1,1-1.29l9.2-1.18a1.11,1.11,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.3l-9.2,1.18Zm30.65-3.93a1.15,1.15,0,0,1-.15-2.3l9.2-1.18a1.11,1.11,0,0,1,1.29,1,1.15,1.15,0,0,1-1,1.3l-9.19,1.17Zm30.65-3.92a1.16,1.16,0,0,1-1.15-1,1.17,1.17,0,0,1,1-1.3l9.19-1.17a1.1,1.1,0,0,1,1.3,1,1.17,1.17,0,0,1-1,1.3l-9.19,1.17Zm30.65-3.92a1.16,1.16,0,0,1-.15-2.31l9.19-1.17a1.11,1.11,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.29l-9.2,1.18Zm30.65-3.92a1.16,1.16,0,0,1-.15-2.31l9.19-1.18a1.12,1.12,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.29l-9.2,1.18Zm30.64-3.92a1.17,1.17,0,0,1-1.15-1,1.16,1.16,0,0,1,1-1.29l9.19-1.18a1.12,1.12,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.3l-9.2,1.18Zm30.65-3.92a1.16,1.16,0,0,1-.15-2.31l9.2-1.18a1.15,1.15,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.3l-9.19,1.18Zm287.21,0a1.17,1.17,0,0,1-1.14-1c-.55-3-1.13-6.06-1.73-9.08a1.15,1.15,0,0,1,.91-1.36,1.13,1.13,0,0,1,1.36.91c.6,3,1.19,6.08,1.74,9.12a1.17,1.17,0,0,1-.93,1.35Zm-256.56-3.91a1.15,1.15,0,0,1-.15-2.3l9.19-1.18a1.13,1.13,0,0,1,1.3,1,1.17,1.17,0,0,1-1,1.3l-9.19,1.17Zm30.65-3.92a1.16,1.16,0,0,1-1.15-1,1.17,1.17,0,0,1,1-1.3l9.2-1.17a1.1,1.1,0,0,1,1.29,1,1.17,1.17,0,0,1-1,1.3l-9.19,1.17Zm30.65-3.92a1.16,1.16,0,0,1-.15-2.31l9.19-1.17a1.11,1.11,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.29l-9.2,1.18Zm30.64-3.92a1.16,1.16,0,0,1-.14-2.31l9.19-1.18a1.13,1.13,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.29l-9.2,1.18Zm30.65-3.92a1.16,1.16,0,0,1-.15-2.31l9.2-1.18a1.12,1.12,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.3l-9.19,1.18Zm30.65-3.93a1.15,1.15,0,0,1-.15-2.3l9.2-1.18a1.12,1.12,0,0,1,1.29,1,1.15,1.15,0,0,1-1,1.3l-9.19,1.17Zm30.65-3.92a1.16,1.16,0,0,1-.15-2.31l9.2-1.17a1.11,1.11,0,0,1,1.29,1,1.17,1.17,0,0,1-1,1.3l-9.19,1.17Zm66.24-2.79a1.15,1.15,0,0,1-1.12-.88c-.37-1.51-.75-3-1.13-4.51l-2.55.33a1.16,1.16,0,1,1-.29-2.3l4.57-.59.26,1q.7,2.76,1.39,5.53a1.16,1.16,0,0,1-.85,1.4A1.33,1.33,0,0,1,2167.68,1880.88Zm-35.59-1.13a1.16,1.16,0,0,1-.15-2.31l9.19-1.17a1.1,1.1,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.29l-9.19,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1757,1797.26l-.46-13.68a10.47,10.47,0,0,1,7.1-7.08c12.81-3.76,44.78-11.57,61.89-1.89l4.34,15.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1796.17,1779a18.86,18.86,0,0,1-9.05,1.15,8.24,8.24,0,0,1-7.25-7.12l-5.41-42.33L1796,1728l5.41,42.3A8.27,8.27,0,0,1,1796.17,1779Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1965.64,1770.56l-.47-13.68a10.47,10.47,0,0,1,7.11-7.08c12.81-3.76,44.77-11.57,61.88-1.89l4.35,15.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2004.82,1752.32a18.84,18.84,0,0,1-9,1.15,8.23,8.23,0,0,1-7.24-7.12l-6-46.79,21.54-2.76,6,46.76A8.25,8.25,0,0,1,2004.82,1752.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1770.41,1716.5l231-34.56c5.27-.78,9.43-3.8,9.92-7.23a39.49,39.49,0,0,0-1.69-18.89c-2.94-8-14.73-12.63-27.75-11.17-43.31,4.87-153.33,19-212,42.09-6.21,2.44-10.52,6.56-11.59,11-1,4.28-1.36,9.85,1.37,15.14C1761.17,1715.72,1765.68,1717.21,1770.41,1716.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1767.91,1731.92a3.11,3.11,0,0,1-3-2.39,57.62,57.62,0,0,1-.88-18.39,21.56,21.56,0,0,1,12.66-16.66c12.52-5.48,36.54-15.14,56.85-18.32a3.09,3.09,0,1,1,1,6.1c-20.35,3.19-45.46,13.57-55.32,17.88a15.32,15.32,0,0,0-9,11.84,50.93,50.93,0,0,0,.78,16.15,3.11,3.11,0,0,1-2.32,3.71A3.34,3.34,0,0,1,1767.91,1731.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1648.82,1805.74c74.73-10.53,398.07-55.36,493.58-56a19.3,19.3,0,0,1,18.35,12.72c8.78,24.42,27.42,81.35,33.5,139.37a16.9,16.9,0,0,1-11.68,17.75l-209.49,68.08-76.26,9.76-234.57-16.2a18,18,0,0,1-16.55-14.75c-5.21-28.92-16.28-96.92-14-141.89A20,20,0,0,1,1648.82,1805.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1896.27,1979.8h-.08l-9.24-.64a1.16,1.16,0,0,1-1.08-1.24,1.18,1.18,0,0,1,1.24-1.07l9.24.64a1.16,1.16,0,0,1-.08,2.31Zm-30.82-2.13h-.08l-9.25-.64a1.16,1.16,0,0,1-1.08-1.24,1.18,1.18,0,0,1,1.24-1.07l9.25.64a1.16,1.16,0,0,1-.08,2.31Zm50.47-.38a1.16,1.16,0,0,1-.15-2.31l9.2-1.18a1.12,1.12,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.3l-9.19,1.18Zm-81.3-1.75h-.08l-9.24-.64a1.15,1.15,0,0,1-1.08-1.23,1.21,1.21,0,0,1,1.23-1.08l9.25.64a1.16,1.16,0,0,1-.08,2.31Zm-30.82-2.13h-.08l-9.25-.64a1.15,1.15,0,0,1-1.07-1.23,1.2,1.2,0,0,1,1.23-1.08l9.25.64a1.16,1.16,0,0,1-.08,2.31Zm142.77,0a1.16,1.16,0,0,1-.15-2.31l9.19-1.18a1.12,1.12,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.3l-9.19,1.18ZM1773,1971.29h-.08l-9.25-.63a1.17,1.17,0,0,1-1.08-1.24,1.2,1.2,0,0,1,1.24-1.08l9.24.64a1.17,1.17,0,0,1,1.08,1.24A1.16,1.16,0,0,1,1773,1971.29Zm-30.83-2.13h-.08l-9.25-.63a1.16,1.16,0,0,1-1.07-1.24,1.18,1.18,0,0,1,1.23-1.08l9.25.64a1.16,1.16,0,0,1-.08,2.32Zm234.73-1.23a1.16,1.16,0,0,1-.36-2.26l8.82-2.87a1.17,1.17,0,0,1,1.46.75,1.16,1.16,0,0,1-.75,1.46l-8.81,2.86A1.13,1.13,0,0,1,1976.88,1967.93Zm-265.56-.9h-.07l-9.25-.64a1.16,1.16,0,1,1,.16-2.31l9.24.63a1.16,1.16,0,0,1-.08,2.32Zm-30.82-2.13h-.08l-9.25-.64a1.15,1.15,0,0,1-1.07-1.24,1.18,1.18,0,0,1,1.23-1.07l9.25.63a1.16,1.16,0,0,1-.08,2.32Zm325.76-6.52a1.16,1.16,0,0,1-.36-2.26l8.82-2.87a1.16,1.16,0,0,1,.72,2.21l-8.82,2.86A1.13,1.13,0,0,1,2006.26,1958.38Zm-344.75-8.75a1.17,1.17,0,0,1-1.14-1c-.48-2.88-1-6-1.49-9.16a1.16,1.16,0,0,1,1-1.33,1.15,1.15,0,0,1,1.32,1q.78,4.81,1.5,9.14a1.17,1.17,0,0,1-1,1.34Zm374.14-.8a1.18,1.18,0,0,1-1.11-.8,1.16,1.16,0,0,1,.75-1.46l8.81-2.87a1.16,1.16,0,0,1,.72,2.21l-8.81,2.86A1.13,1.13,0,0,1,2035.65,1948.83Zm29.38-9.55a1.16,1.16,0,0,1-.36-2.26l8.82-2.87a1.16,1.16,0,0,1,.72,2.21l-8.82,2.86A1.13,1.13,0,0,1,2065,1939.28Zm29.39-9.55a1.16,1.16,0,0,1-.36-2.26l8.82-2.87a1.16,1.16,0,0,1,.71,2.21l-8.81,2.86A1.13,1.13,0,0,1,2094.42,1929.73Zm29.38-9.55a1.16,1.16,0,0,1-.35-2.26l8.81-2.87a1.17,1.17,0,0,1,1.46.74,1.15,1.15,0,0,1-.74,1.46l-8.82,2.87A1.09,1.09,0,0,1,2123.8,1920.18Zm-467-1.11a1.15,1.15,0,0,1-1.14-1c-.42-3-.84-6.09-1.25-9.2a1.16,1.16,0,0,1,1-1.3,1.13,1.13,0,0,1,1.3,1q.62,4.67,1.24,9.18a1.16,1.16,0,0,1-1,1.31Zm496.37-8.44a1.16,1.16,0,0,1-.36-2.26l8.81-2.87a1.16,1.16,0,0,1,.72,2.2l-8.81,2.87A1.13,1.13,0,0,1,2153.19,1910.63Zm21.49-14.61a1.16,1.16,0,0,1-1.15-1c-.4-3.06-.82-6.12-1.27-9.16a1.16,1.16,0,0,1,2.29-.35q.67,4.61,1.28,9.21a1.16,1.16,0,0,1-1,1.3ZM1653,1888.39a1.16,1.16,0,0,1-1.15-1q-.48-4.62-.91-9.24a1.16,1.16,0,0,1,2.31-.22c.28,3.07.58,6.15.91,9.22a1.17,1.17,0,0,1-1,1.27Zm516.69-22.88a1.16,1.16,0,0,1-1.14-.93q-.89-4.59-1.84-9.07a1.16,1.16,0,1,1,2.27-.48c.63,3,1.25,6,1.84,9.1a1.15,1.15,0,0,1-.91,1.36A.86.86,0,0,1,2169.73,1865.51Zm-519.17-7.94a1.16,1.16,0,0,1-1.16-1.1q-.24-4.71-.39-9.29a1.15,1.15,0,0,1,1.12-1.19,1.21,1.21,0,0,1,1.2,1.12c.09,3,.22,6.12.38,9.24a1.15,1.15,0,0,1-1.09,1.22ZM2163,1835.34a1.17,1.17,0,0,1-1.13-.87c-.76-3-1.52-6-2.3-9a1.17,1.17,0,0,1,.83-1.42,1.14,1.14,0,0,1,1.41.83q1.17,4.41,2.31,9a1.15,1.15,0,0,1-.84,1.41A1.33,1.33,0,0,1,2163,1835.34Zm-512.73-8.6h0a1.21,1.21,0,0,1-1.15-1.22,1.79,1.79,0,0,1,0-.24,2.4,2.4,0,0,1,2.1-2.22l7.33-1a1.15,1.15,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.31l-7.33,1.1-.14.23A1.09,1.09,0,0,1,1650.29,1826.74Zm29.89-5.39a1.16,1.16,0,0,1-.16-2.31l9.19-1.27a1.15,1.15,0,0,1,1.3,1,1.17,1.17,0,0,1-1,1.31l-9.19,1.27Zm30.62-4.22a1.16,1.16,0,0,1-1.15-1,1.17,1.17,0,0,1,1-1.31l9.19-1.25a1.16,1.16,0,0,1,1.31,1,1.17,1.17,0,0,1-1,1.31l-9.18,1.25Zm30.63-4.16a1.16,1.16,0,0,1-.15-2.31l9.18-1.24a1.16,1.16,0,1,1,.31,2.3l-9.18,1.24Zm30.64-4.1a1.16,1.16,0,0,1-.16-2.31l9.2-1.22a1.15,1.15,0,1,1,.3,2.29l-9.19,1.22Zm382.79-3.34a1.16,1.16,0,0,1-1.11-.83c-.92-3.07-1.82-6-2.7-8.86a1.16,1.16,0,1,1,2.21-.69q1.34,4.26,2.71,8.89a1.15,1.15,0,0,1-.78,1.44A1.26,1.26,0,0,1,2154.86,1805.53Zm-352.15-.71a1.15,1.15,0,0,1-.15-2.3l9.19-1.21a1.18,1.18,0,0,1,1.3,1,1.16,1.16,0,0,1-1,1.3l-9.19,1.2Zm30.65-4a1.16,1.16,0,0,1-.15-2.31l9.2-1.18a1.14,1.14,0,0,1,1.3,1,1.17,1.17,0,0,1-1,1.3l-9.19,1.18ZM1864,1797a1.16,1.16,0,0,1-.14-2.31l9.19-1.16a1.16,1.16,0,1,1,.29,2.3l-9.19,1.16Zm30.67-3.82a1.16,1.16,0,0,1-.14-2.31l9.2-1.13a1.12,1.12,0,0,1,1.29,1,1.15,1.15,0,0,1-1,1.29l-9.2,1.13Zm30.67-5.41c-.58,0-1.08-.22-1.15-.52s.38-.61,1-.65l9.21-.56c.67,0,1.21.2,1.28.52s-.38.61-1,.65l-9.2.56Zm30.69-1.93a1.16,1.16,0,0,1-.13-2.31l9.21-1.06a1.16,1.16,0,0,1,.26,2.31l-9.21,1.06Zm30.7-3.47a1.16,1.16,0,0,1-.13-2.31l9.22-1a1.13,1.13,0,0,1,1.28,1,1.16,1.16,0,0,1-1,1.28l-9.21,1Zm30.73-3.31a1.18,1.18,0,0,1-1.16-1,1.16,1.16,0,0,1,1-1.27l9.23-1a1.19,1.19,0,0,1,1.27,1,1.16,1.16,0,0,1-1,1.27l-9.22,1Zm127.93-2.91a1.18,1.18,0,0,1-1.1-.79c-.74-2.14-1.43-4.08-2.05-5.81l-1.56,0h0a1.17,1.17,0,0,1-1.16-1.15,1.15,1.15,0,0,1,1.14-1.17l1.87,0a1.85,1.85,0,0,1,1.77,1.14c.66,1.84,1.4,3.92,2.2,6.24a1.15,1.15,0,0,1-.72,1.47A1.21,1.21,0,0,1,2145.4,1776.1Zm-97.19-.19a1.16,1.16,0,0,1-.11-2.31l9.23-.87a1.12,1.12,0,0,1,1.26,1,1.16,1.16,0,0,1-1,1.26l-9.23.87Zm30.77-2.78a1.16,1.16,0,0,1-.09-2.31l9.24-.75a1.12,1.12,0,0,1,1.25,1.06,1.16,1.16,0,0,1-1.07,1.25l-9.23.75Zm30.82-2.3a1.16,1.16,0,0,1-.07-2.31q4.83-.3,9.26-.54a1.16,1.16,0,1,1,.13,2.31q-4.42.24-9.25.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1970,2020.55l-66.81,8.55a17.4,17.4,0,0,1-19.11-13l-15.95-63.3a17.39,17.39,0,0,1,14.71-21.45l80.26-10.27a17.39,17.39,0,0,1,19.62,16.53l2.49,65A17.39,17.39,0,0,1,1970,2020.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1960.27,2009.78l-50.85,6.51a13.26,13.26,0,0,1-14.55-9.88l-12.13-48.18a13.22,13.22,0,0,1,11.19-16.32l61.09-7.82a13.24,13.24,0,0,1,14.93,12.58l1.9,49.49A13.25,13.25,0,0,1,1960.27,2009.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1920.53,1497.46c15.76,65.11,16.18,128.82,13.78,152a18.07,18.07,0,0,1-16.7,16.19c-10,.7-23.53,1.61-35.64,2.31-13.32.77-28.1-7.65-38-14.69a6,6,0,0,0-8.76,7.52c4.86,9.5,13.3,17,21.67,23.35,5,3.82,21.77,10.62,20.61,18.16a13.49,13.49,0,0,1-3.35,6.29c-9.3,11.16-23.37,17.12-37.26,21.39-1.75.53-3.59,1.1-4.81,2.45-.35,9,27.28,19,34.41,21.33a79.32,79.32,0,0,0,33.24,3.87c27.81-2.93,53.48-22.12,68.46-45.26,40-61.86,60.73-136.55,68.29-193.68C1999.24,1481.47,1943,1490.91,1920.53,1497.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M2036.48,1524.58c29.7-224.35-143.19-396.86-143.19-396.86l-102.87,119.92c78.1,97.35,115.22,186.55,132.18,256.61C1945.09,1497.7,1999.24,1487.35,2036.48,1524.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1920.15,1503.15a6.38,6.38,0,0,1-6.19-4.87c-20.9-86.37-65-171.87-131-254.12a6.37,6.37,0,1,1,9.93-8c67.17,83.72,112.06,170.9,133.41,259.09a6.38,6.38,0,0,1-4.7,7.69A6.47,6.47,0,0,1,1920.15,1503.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M527,2833.15a12.53,12.53,0,0,0-.33-3.32C510.12,2764.24,428,2723.39,428,2723.39l-32.54,2.55c-18.71,57.81-16.3,93.26-13.3,109,.09.45.22.87.34,1.3C409.35,2838.68,464.59,2840.25,527,2833.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M382.51,2836.29c1.45,5.27,5.34,9.38,10.32,10.42,38.18,8,98.87,1.57,124.35-1.76,5.62-.73,9.73-5.93,9.82-11.8C464.59,2840.25,409.35,2838.68,382.51,2836.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M382.39,2677.47l13.78,66.34c1,4.87,4.74,8.51,9.27,8.93a91.66,91.66,0,0,0,21.35-.34c7.11-1,12.06-8.27,10.8-16L428,2677.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M667.92,2835.45c-35.94-1-54.52-5.24-64.13-9.17,0,3.57,0,7.21.11,11,.13,4,3.11,7.24,6.77,7.21L808,2843.2c6.3,0,10-7.34,7.25-13.12C789.36,2832.22,723.47,2837,667.92,2835.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M815.23,2830.08a9.65,9.65,0,0,0-.78-1.49c-17.43-24.34-61.81-72.83-149.51-93.86l-42.07-1.32s-18.73,32.56-19.08,92.87c9.61,3.93,28.19,8.16,64.13,9.17C723.47,2837,789.36,2832.22,815.23,2830.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M613.2,2671.6c.66,3.11,9.42,50.31,12.81,68.61a9.15,9.15,0,0,0,8.22,7.77c7.21.4,18.83.45,28.82-2.26,5.39-1.47,9-7,8.62-13.06L667,2658Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M581.32,1800s57.87,397.68,99.64,870.9c.78,8.82-6.25,16.49-14.91,18.31-12.75,2.69-31.51,5.88-47,5.44a17.41,17.41,0,0,1-16.61-14.55c-14.23-83.44-115.76-531.24-142.4-629.79,0,0-30.61,418.64-20.83,635.84a10.28,10.28,0,0,1-9.08,10.7,173,173,0,0,1-37.76-.1,13.79,13.79,0,0,1-12.28-11.7c-10.13-70.61-68.46-490.94-66-793.73.14-17.08,20-157.37,20-157.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M325.41,1822.94a16.35,16.35,0,0,1-10.74-13.79c-7.7-74.66-45-537.62,190.29-728.06,0,0,13.49-35.29,124.38,51.47s51.52,177.71,25,303.15c-32.13,151.8-88.49,275.87-63.55,369.28a12.94,12.94,0,0,1-7.93,15.52C496.69,1852.26,410.88,1853.31,325.41,1822.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M596.72,942.38c-.07,6.59-94,140-94,140s16.86,33.21,97.36,60.17l69.48-142.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M670.68,865.93S704.11,942.71,706.35,983s10.93,66.45-35.67,74.57-85.85-15.1-107.12-55.25c0,0-33.32-61.85-25.84-87.18S670.68,865.93,670.68,865.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M579.49,973.47l2.65-1.17a6.39,6.39,0,0,0,3.12-8.78c-6.57-12.7-19.38-41.79-2.83-48.58,21.33-8.75,105.81-26,124-56,17.52-28.81,2-66-21.33-76.57a3.2,3.2,0,0,0-4.2,1.37L679,787.46a3.16,3.16,0,0,1-5.84-.6h0a3.16,3.16,0,0,0-5.71-.81c-5.6,9-20.73,23.5-61.17,31-57.49,10.61-95.5,33.87-96.44,73.6a3.17,3.17,0,0,1-4.9,2.61c-4.25-2.59-11-3.8-20.12,3.83-15.79,13.28-9.33,47.71,25.28,76a3.14,3.14,0,0,1-.15,5.07c-6.27,4.09-15.62,13.8,8.61,26.76,25.07,13.4,43.79,12.3,51,11.11a3.15,3.15,0,0,0,2.55-3.81l-7.69-34.91a3.16,3.16,0,0,1,3.09-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M580.93,980.84s-12.75-49.05-34.74-35.3,11.41,55,29.09,56.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M665,1172.83l6.48,173.94a476.11,476.11,0,0,0,52.59,14.93c10.43-33.58,33.4-74.8,52.21-105.45C707.18,1231.82,665,1172.83,665,1172.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1010,1169.87c-94.8,102.35-171.53,108.37-233.75,86.38-18.81,30.65-41.78,71.87-52.21,105.45,253.15,55.82,312.76-176.91,312.76-176.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1029.26,1159s10.92-11.73,31.13-8,38.2,10.7,50.79,0,17,3.66,17,3.66l-37.7,28.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1006.71,1179s7.48-31.28,30-27,73.74,32.13,86.93,27,30.06-17.4,38.72-13.06l-15.25,19s39.19-22.61,45.94-8.72l-65.21,36.7S1032.46,1203.36,1006.71,1179Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M559.78,1400.48S738,1549.75,930.46,1484.62a45.84,45.84,0,0,1,36.13,2.72l55.32,29.22a49.38,49.38,0,0,0,65.46-18.33c7.69-12.85,14.25-27.54,15.55-41.61l-108.26-43.83,8-13.27s-52.85-4.48-66.69,33.4c0,0-100.68,41.88-270.47-144.88C665.48,1288,588.43,1353.56,559.78,1400.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M550.19,1398.94a3.06,3.06,0,0,1-1.71-.52c-75-50.71-110.34-132.54-110.69-133.36a3.05,3.05,0,0,1,5.62-2.39c.34.81,35,81,108.49,130.69a3.05,3.05,0,0,1,.81,4.24A3,3,0,0,1,550.19,1398.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M662,1285.51a3,3,0,0,1-2.56-1.4c-.23-.35-23.16-36-66.82-114.23-13.43-24-31.08-39.26-52.45-45.25-35.4-9.89-69.52,9.09-69.86,9.28a3,3,0,0,1-3-5.3c1.47-.84,36.56-20.47,74.46-9.86,23,6.42,41.93,22.62,56.18,48.15,43.56,78,66.4,113.56,66.63,113.91a3,3,0,0,1-.92,4.21A2.94,2.94,0,0,1,662,1285.51Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingImg3);
export default __webpack_public_path__ + "static/media/banking_img_3.8c26d8e598d56e8c4586c9a61d746592.svg";
export { ForwardRef as ReactComponent };